
export default {
  name: 'AdminCategoryToolbar',

  props: {
    category: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isExpanded: false,
      loading: false,
      stats: null,
    }
  },

  computed: {
    isAdmin() {
      return (
        this.$auth.loggedIn && this.$auth.user?.role?.identifier === 'admin'
      )
    },

    categoryIsActive() {
      return this.stats?.is_active ?? this.category.is_active ?? true
    },

    topSellers() {
      return this.stats?.top_sellers || []
    },

    worstSellers() {
      return this.stats?.worst_sellers || []
    },

    urlToAdminPage() {
      return `${this.$config.adminUrl}/categories/${this.category.id}`
    },
  },

  watch: {
    'category.id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.stats = null
          if (this.isExpanded) {
            this.fetchAdminStats()
          }
        }
      },
    },
  },

  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded && !this.stats) {
        this.fetchAdminStats()
      }
    },

    async fetchAdminStats() {
      if (!this.isAdmin) return

      this.loading = true
      try {
        const response = await this.$categoryService.getAdminStats(
          this.category.id
        )
        this.stats = response.data || {}
      } catch (error) {
        console.error('Failed to fetch category admin stats:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
